import { render, staticRenderFns } from "./AppTour.vue?vue&type=template&id=435cb9d4"
import script from "./AppTour.vue?vue&type=script&lang=js"
export * from "./AppTour.vue?vue&type=script&lang=js"
import style0 from "./AppTour.vue?vue&type=style&index=0&id=435cb9d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports